<template>
  <svg width="24"
       height="30"
       viewBox="0 0 56 72"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M39.0899 0H1.87596C0.839885 0 0 0.839885 0 2.46965V70.5247C0 70.9671 0.839885 71.807 1.87596 71.807H53.2615C54.2976 71.807 55.1375 70.9671 55.1375 70.5247V16.6413C55.1375 15.7488 55.0182 15.4616 54.8079 15.25L39.8875 0.329543C39.6759 0.119251 39.3887 0 39.0899 0Z"
          fill="#E9E9E0"/>
    <path d="M39.75 0.194092V15.3877H54.9436L39.75 0.194092Z"
          fill="#D9D7CA"/>
    <path d="M53.2615 71.8068H1.87596C0.839885 71.8068 0 70.967 0 69.9309V50.0083H55.1375V69.9309C55.1375 70.967 54.2976 71.8068 53.2615 71.8068Z"
          fill="#185C37"/>
    <path d="M28.1251 16.8125H18.4584C17.7956 16.8125 17.25 17.3581 17.25 18.0207V23.1563L28.1251 29.5L33.5626 31.7943L39.0001 29.5V23.1563L28.1251 16.8125Z"
          fill="#21A366"/>
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.25 23.1562H28.1251V29.5H17.25V23.1562Z"
          fill="#107C41"/>
    <path d="M37.7918 16.8125H28.125V23.1563H39V18.0207C39 17.3581 38.4544 16.8125 37.7918 16.8125Z"
          fill="#33C481"/>
    <path d="M28.1251 29.5H17.25V40.9793C17.25 41.6419 17.7956 42.1875 18.4584 42.1875H37.7919C38.4545 42.1875 39.0001 41.6419 39.0001 40.9793V35.8438L28.1251 29.5Z"
          fill="#185C37"/>
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.125 29.5H39V35.8438H28.125V29.5Z"
          fill="#107C41"/>
    <path d="M25.1043 21.3438H17.25V38.5625H25.1043C25.7663 38.5607 26.3107 38.0163 26.3125 37.3543V22.552C26.3107 21.89 25.7663 21.3456 25.1043 21.3438Z"
          fill="black"
          fill-opacity="0.094118"/>
    <path d="M24.198 22.25H17.25V39.4688H24.198C24.86 39.4669 25.4044 38.9225 25.4063 38.2605V23.4582C25.4044 22.7963 24.86 22.2518 24.198 22.25Z"
          fill="black"
          fill-opacity="0.2"/>
    <path d="M24.198 22.25H17.25V37.6563H24.198C24.86 37.6544 25.4044 37.11 25.4063 36.448V23.4582C25.4044 22.7963 24.86 22.2518 24.198 22.25Z"
          fill="black"
          fill-opacity="0.2"/>
    <path d="M23.2918 22.25H17.25V37.6563H23.2918C23.9538 37.6544 24.4982 37.11 24.5 36.448V23.4582C24.4982 22.7963 23.9538 22.2518 23.2918 22.25Z"
          fill="black"
          fill-opacity="0.2"/>
    <path d="M11.2082 22.25H23.2918C23.9544 22.25 24.5 22.7956 24.5 23.4582V35.5418C24.5 36.2044 23.9545 36.75 23.2918 36.75H11.2082C10.5456 36.75 10 36.2044 10 35.5418V23.4582C10 22.7956 10.5456 22.25 11.2082 22.25Z"
          fill="#107C41"/>
    <path d="M13.2021 34.0313L16.1346 29.4873L13.4486 24.9688H15.6101L17.0763 27.8568C17.211 28.1308 17.3037 28.3353 17.3543 28.47H17.3733C17.47 28.251 17.5713 28.0381 17.6767 27.8316L19.2439 24.9688H21.2284L18.4729 29.462L21.2979 34.0313H19.187L17.4932 30.8588C17.4135 30.7239 17.3459 30.5821 17.291 30.4354H17.2658C17.2163 30.5792 17.1506 30.7169 17.0698 30.846L15.3256 34.0313H13.2021Z"
          fill="white"/>
    <path d="M16.8563 67H14.7283L11.7443 62.392L8.80031 67H6.92031L10.8243 61.104L7.05631 55.432H9.16831L11.8963 59.664L14.6003 55.432H16.4563L12.8003 60.912L16.8563 67ZM18.9329 55.432H20.6689V65.496H26.0129V67H18.9249L18.9329 55.432ZM32.4806 67.16C31.9312 67.16 31.3952 67.0907 30.8726 66.952C30.3499 66.8133 29.8752 66.608 29.4486 66.336C29.0219 66.0587 28.6672 65.7147 28.3846 65.304C28.1072 64.8933 27.9339 64.4133 27.8646 63.864H29.6486C29.7392 64.28 29.9179 64.6293 30.1846 64.912C30.4566 65.1947 30.7899 65.408 31.1846 65.552C31.5792 65.696 32.0086 65.768 32.4726 65.768C32.9846 65.768 33.4432 65.6987 33.8486 65.56C34.2592 65.416 34.5846 65.2133 34.8246 64.952C35.0646 64.6853 35.1846 64.3653 35.1846 63.992C35.1846 63.656 35.1019 63.3707 34.9366 63.136C34.7766 62.9013 34.5472 62.7067 34.2486 62.552C33.9552 62.392 33.6006 62.2667 33.1846 62.176L30.9926 61.68C30.1339 61.4987 29.4566 61.1627 28.9606 60.672C28.4699 60.176 28.2219 59.52 28.2166 58.704C28.2112 58.0213 28.3899 57.424 28.7526 56.912C29.1206 56.4 29.6219 56.0027 30.2566 55.72C30.8912 55.432 31.6139 55.288 32.4246 55.288C33.3686 55.288 34.1606 55.4453 34.8006 55.76C35.4459 56.0747 35.9339 56.4907 36.2646 57.008C36.5952 57.52 36.7632 58.0773 36.7686 58.68H35.0166C34.9739 58.1893 34.8299 57.8 34.5846 57.512C34.3392 57.224 34.0299 57.0187 33.6566 56.896C33.2886 56.768 32.8832 56.704 32.4406 56.704C32.1206 56.704 31.8139 56.744 31.5206 56.824C31.2272 56.904 30.9686 57.0213 30.7446 57.176C30.5206 57.3307 30.3419 57.5227 30.2086 57.752C30.0806 57.976 30.0166 58.2347 30.0166 58.528C30.0166 58.9227 30.1499 59.2427 30.4166 59.488C30.6832 59.7333 31.1739 59.944 31.8886 60.12L34.0326 60.608C34.6459 60.736 35.1419 60.9253 35.5206 61.176C35.8992 61.4213 36.1899 61.7013 36.3926 62.016C36.5952 62.3307 36.7339 62.6587 36.8086 63C36.8832 63.336 36.9206 63.6587 36.9206 63.968C36.9206 64.5653 36.7419 65.1067 36.3846 65.592C36.0272 66.072 35.5179 66.4533 34.8566 66.736C34.1952 67.0187 33.4032 67.16 32.4806 67.16ZM48.0751 67H45.9471L42.9631 62.392L40.0191 67H38.1391L42.0431 61.104L38.2751 55.432H40.3871L43.1151 59.664L45.8191 55.432H47.6751L44.0191 60.912L48.0751 67Z"
          fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'XLSXIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
